<template>
  <transition name="modal-fade">
    <div class="overlay" v-if="mostrar" @click.self="fechar">
      <div class="modal-content">
        <!-- Cabeçalho do Modal -->
        <div class="modal-header">

          <span class="modal-label">Membros da Equipe</span>
          <button class="btn-fechar-modal" @click="fechar" title="Fechar">
            ×
          </button>
        </div>

        <!-- Banner com Foto e Nome da Ação -->
        <div class="acao-hero-banner">
          <div class="acao-hero-conteudo">
            <!-- Foto da Ação -->
            <div class="acao-foto-container">
              <img v-if="imagemAcao && !fotoAcaoComErro" :src="imagemAcao" alt="Foto da Ação" class="acao-foto-img"
                @error="fotoAcaoComErro = true" />
              <div v-else class="acao-foto-placeholder">
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" viewBox="0 0 16 16">
                  <path
                    d="M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm5.5 1.5v2a1 1 0 0 0 1 1h2l-3-3zM10.5 8a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0z" />
                  <path
                    d="M1 11.5v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-1.5v1.5a.5.5 0 0 1-1 0zm0 3v-1.5a.5.5 0 0 1 1 0V14h1.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5zm14-3v-1.5a.5.5 0 0 0-1 0V13h-1.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 .5-.5zm0 3v-2a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0 0 1h1.5v1.5a.5.5 0 0 0 1 0z" />
                </svg>
              </div>
            </div>

            <!-- Informações da Ação -->
            <div class="acao-hero-info">
              <span class="acao-tag">Ação de Extensão</span>
              <h4 class="acao-titulo" :title="nomeAcao">
                {{ nomeAcao || "Ação de Extensão" }}
              </h4>
            </div>
          </div>

          <!-- Total de Integrantes -->
          <div class="acao-hero-meta" v-if="!carregando && membros.length > 0">
            <div class="pill-contador">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                <path
                  d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1zm-7.978-1A2.24 2.24 0 0 1 7 12c0-1.355.68-2.75 1.936-3.72A6.3 6.3 0 0 0 8 8c-4 0-5 3-5 4s1 1 1 1zM8 7a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5.784 6A2.24 2.24 0 0 1 2 12c0-1.355.68-2.75 1.936-3.72A6.3 6.3 0 0 0 2 8c-4 0-5 3-5 4s1 1 1 1zM2 7a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
              </svg>
              <span>{{ membros.length }}
                {{ membros.length === 1 ? "integrante" : "integrantes" }}</span>
            </div>
          </div>
        </div>

        <!-- Corpo do Modal com Scroll -->
        <div class="modal-body">
          <!-- Estado de Carregamento -->
          <div v-if="carregando" class="estado-container">
            <div class="spinner"></div>
            <p class="estado-texto">Carregando membros da equipe...</p>
          </div>

          <!-- Estado de Erro -->
          <div v-else-if="erro" class="estado-container estado-erro">
            <div class="erro-icone">!</div>
            <p class="estado-texto">{{ erro }}</p>
            <button class="btn-tentar-novamente" @click="carregarMembros">
              Tentar novamente
            </button>
          </div>

          <!-- Estado Vazio (sem membros) -->
          <div v-else-if="!membros || membros.length === 0" class="estado-container estado-vazio">
            <div class="vazio-icone-circulo">
              <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="currentColor" viewBox="0 0 16 16">
                <path
                  d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1zm-7.978-1A2.24 2.24 0 0 1 7 12c0-1.355.68-2.75 1.936-3.72A6.3 6.3 0 0 0 8 8c-4 0-5 3-5 4s1 1 1 1zM8 7a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5.784 6A2.24 2.24 0 0 1 2 12c0-1.355.68-2.75 1.936-3.72A6.3 6.3 0 0 0 2 8c-4 0-5 3-5 4s1 1 1 1zM2 7a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
              </svg>
            </div>
            <h4>Nenhum membro encontrado</h4>
            <p class="estado-texto">
              Esta ação ainda não possui membros vinculados à equipe.
            </p>
          </div>

          <!-- Grid de 2 Colunas dos Membros -->
          <div v-else class="cards-membros-grid">
            <div v-for="(membro, index) in membros" :key="membro.id || index" class="membro-card">
              <!-- Foto de Perfil / Avatar do Membro -->
              <div class="membro-avatar-wrapper">
                <img v-if="membro.fotoPerfil && !fotosComErro[membro.id || index]" :src="membro.fotoPerfil"
                  :alt="membro.nome" class="membro-avatar-img" @error="onFotoErro(membro.id || index)" />
                <div v-else class="membro-avatar-fallback" :style="{ background: getCorAvatar(membro.nome) }">
                  {{ getIniciais(membro.nome) }}
                </div>
              </div>

              <!-- Informações do Integrante -->
              <div class="membro-card-corpo">
                <div class="membro-topo-info">
                  <h5 class="membro-nome" :title="membro.nome">
                    {{ membro.nome || "Nome não informado" }}
                  </h5>
                </div>

                <div class="membro-tag-wrapper">
                  <span class="badge-vinculo" :class="getClasseVinculo(
                    membro.tipoVinculo ||
                    membro.funcaoMembro ||
                    membro.funcao
                  )
                    ">
                    <span class="badge-dot"></span>
                    {{
                      formatarVinculo(
                        membro.tipoVinculo ||
                        membro.funcaoMembro ||
                        membro.funcao
                      )
                    }}
                  </span>
                </div>

                <div v-if="membro.email" class="membro-detalhe" :title="membro.email">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor"
                    viewBox="0 0 16 16">
                    <path
                      d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555ZM0 4.697v7.104l5.803-3.558L0 4.697ZM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757Zm3.436-.586L16 11.801V4.697l-5.803 3.546Z" />
                  </svg>
                  <span class="detalhe-texto">{{ membro.email }}</span>
                </div>

                <div v-if="membro.cargaHoraria" class="membro-detalhe">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor"
                    viewBox="0 0 16 16">
                    <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z" />
                    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z" />
                  </svg>
                  <span class="detalhe-texto">{{ membro.cargaHoraria }}h semanais</span>
                </div>
              </div>
            </div>
          </div>
        </div>


      </div>
    </div>
  </transition>
</template>

<script setup>
import { ref, watch, reactive } from "vue";
import acaoService from "@/service/acaoService";

const props = defineProps({
  mostrar: {
    type: Boolean,
    default: false,
  },
  acaoId: {
    type: [String, Number],
    required: true,
  },
  nomeAcao: {
    type: String,
    default: "",
  },
  imagemAcao: {
    type: String,
    default: null,
  },
});

const emit = defineEmits(["fechar"]);

const membros = ref([]);
const carregando = ref(false);
const erro = ref(null);
const fotosComErro = reactive({});
const fotoAcaoComErro = ref(false);

function fechar() {
  emit("fechar");
}

function onFotoErro(identificador) {
  fotosComErro[identificador] = true;
}

function getIniciais(nome) {
  if (!nome) return "?";
  const partes = nome.trim().split(/\s+/);
  if (partes.length === 1) return partes[0].substring(0, 2).toUpperCase();
  return (partes[0][0] + partes[partes.length - 1][0]).toUpperCase();
}

const coresAvatares = [
  "linear-gradient(135deg, hsl(265, 60%, 88%), hsl(265, 70%, 75%))",
  "linear-gradient(135deg, hsl(210, 70%, 88%), hsl(210, 75%, 75%))",
  "linear-gradient(135deg, hsl(150, 60%, 88%), hsl(150, 65%, 75%))",
  "linear-gradient(135deg, hsl(25, 80%, 88%), hsl(25, 85%, 75%))",
  "linear-gradient(135deg, hsl(330, 65%, 88%), hsl(330, 70%, 75%))",
  "linear-gradient(135deg, hsl(180, 60%, 88%), hsl(180, 65%, 75%))",
];

function getCorAvatar(nome) {
  if (!nome) return coresAvatares[0];
  let hash = 0;
  for (let i = 0; i < nome.length; i++) {
    hash = nome.charCodeAt(i) + ((hash << 5) - hash);
  }
  const index = Math.abs(hash) % coresAvatares.length;
  return coresAvatares[index];
}

function formatarVinculo(vinculo) {
  if (!vinculo) return "Membro";
  const map = {
    AGENTE: "Agente",
    Agente: "Agente",
    BOLSISTA: "Bolsista",
    Bolsista: "Bolsista",
    COORDENADOR: "Coordenador",
    Coordenador: "Coordenador",
    VICE_COORDENADOR: "Vice-Coordenador",
    COLABORADOR: "Colaborador",
    Colaborador: "Colaborador",
    VOLUNTARIO: "Voluntário",
    Voluntário: "Voluntário",
    ORIENTADOR: "Orientador",
    Orientador: "Orientador",
    DOCENTE: "Docente",
    Docente: "Docente",
    DISCENTE: "Discente",
    Discente: "Discente",
    TECNICO_ADMINISTRATIVO: "Técnico-Administrativo",
  };
  return (
    map[vinculo] || map[vinculo.toUpperCase?.()] || vinculo.replace(/_/g, " ")
  );
}

function getClasseVinculo(vinculo) {
  if (!vinculo) return "vinculo-padrao";
  const upper = String(vinculo).toUpperCase();
  if (upper.includes("COORDENADOR")) return "vinculo-coordenador";
  if (upper.includes("BOLSISTA")) return "vinculo-bolsista";
  if (upper.includes("AGENTE")) return "vinculo-agente";
  if (upper.includes("VOLUNTARIO") || upper.includes("VOLUNTÁRIO"))
    return "vinculo-voluntario";
  return "vinculo-padrao";
}

async function carregarMembros() {
  if (!props.acaoId) return;
  try {
    carregando.value = true;
    erro.value = null;
    const data = await acaoService.getMembrosTime(props.acaoId);
    membros.value = Array.isArray(data) ? data : [];
  } catch (err) {
    console.error("Erro ao carregar membros da equipe:", err);
    erro.value = "Não foi possível carregar a lista de membros da equipe.";
  } finally {
    carregando.value = false;
  }
}

watch(
  () => props.mostrar,
  (visivel) => {
    if (visivel) {
      fotoAcaoComErro.value = false;
      carregarMembros();
    }
  },
  { immediate: true }
);
</script>

<style scoped>
.modal-content {
  border-radius: 16px;
  width: 100%;
  max-width: 820px;
  max-height: 88vh;
  box-shadow:
    0 20px 25px -5px hsla(0, 0%, 0%, 0.15),
    0 10px 10px -5px hsla(0, 0%, 0%, 0.08);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* ========== CABEÇALHO DO MODAL ========== */



/* ========== HERO BANNER DA AÇÃO COM FOTO ========== */
.acao-hero-banner {
  padding: 1rem;
  display: flex;
  background: var(--branco);
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.acao-hero-conteudo {
  display: flex;
  align-items: center;
  gap: 16px;
  min-width: 0;
  flex: 1;
}

.acao-foto-container {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  overflow: hidden;
  border: 2px solid var(--roxo-superficie);
  box-shadow: 0 2px 4px hsla(0, 0%, 0%, 0.06);
  flex-shrink: 0;
  background: var(--roxo-superficie);
}

.acao-foto-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.acao-foto-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--roxo-claro);
  background: var(--roxo-superficie);
}

.acao-hero-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  flex: 1;
}

.acao-tag {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--roxo-medio);
}

.acao-titulo {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: var(--roxo-escuro);
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pill-contador {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--branco);
  border: 1.5px solid var(--roxo-superficie);
  color: var(--roxo-primario);
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  box-shadow: 0 1px 2px 0 hsla(0, 0%, 0%, 0.04);
}

/* ========== CORPO COM SCROLL SUAVE ========== */
.modal-body {
  background: var(--branco);
  padding: 1rem;
  overflow-y: auto;
  flex: 1;
  min-height: 260px;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior-y: contain;
  scrollbar-color: var(--roxo-primario) transparent;
}

/* Custom Scrollbar Suave */
.modal-body::-webkit-scrollbar {
  width: 8px;
}

.modal-body::-webkit-scrollbar-track {
  background: transparent;
  margin: 8px 0;
}

.modal-body::-webkit-scrollbar-thumb {
  background-color: var(--roxo-claro);
  border-radius: 999px;
  border: 2px solid var(--branco);
  transition: background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.modal-body::-webkit-scrollbar-thumb:hover {
  background-color: var(--roxo-claro);
}

/* ========== GRID DE 2 LADOS (2 COLUNAS) ========== */
.cards-membros-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

/* ========== CARD DO MEMBRO (HORIZONTAL ESTILOSO) ========== */
.membro-card {
  background: var(--branco);
  border: 1.5px solid var(--roxo-superficie);
  border-radius: 12px;
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow:
    0 1px 3px 0 hsla(0, 0%, 0%, 0.05),
    0 1px 2px 0 hsla(0, 0%, 0%, 0.03);
  transition:
    border-color 0.2s cubic-bezier(0.4, 0, 0.2, 1),
    box-shadow 0.2s cubic-bezier(0.4, 0, 0.2, 1),
    transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  min-width: 0;
  contain: content;
}

.membro-card:hover {
  transform: translateY(-2px);
  border-color: var(--roxo-claro);
  box-shadow:
    0 8px 16px -2px hsla(258, 53%, 28%, 0.1),
    0 3px 6px -1px hsla(0, 0%, 0%, 0.05);
}

.membro-avatar-wrapper {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid var(--roxo-superficie);
  box-shadow: 0 2px 4px hsla(0, 0%, 0%, 0.06);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.membro-avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.membro-avatar-fallback {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 700;
  color: var(--roxo-primario);
}

.membro-card-corpo {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
  flex: 1;
}

.membro-topo-info {
  display: flex;
  align-items: center;
  min-width: 0;
}

.membro-nome {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: var(--roxo-escuro);
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}

.membro-tag-wrapper {
  display: flex;
  align-items: center;
}

.badge-vinculo {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px;
  border-radius: 14px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.2px;
  white-space: nowrap;
}

.badge-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
}

.vinculo-coordenador {
  background-color: var(--roxo-superficie);
  color: var(--roxo-primario);
  border: 1px solid var(--roxo-claro);
}

.vinculo-bolsista {
  background-color: var(--verde-claro);
  color: var(--verde-escuro);
  border: 1px solid var(--verde-claro);
}

.vinculo-agente {
  background-color: var(--cinza-claro);
  color: var(--cinza-escuro);
  border: 1px solid var(--cinza-claro);
}

.vinculo-voluntario {
  background-color: var(--cinza-claro);
  color: var(--cinza-escuro);
  border: 1px solid var(--cinza-claro);
}

.vinculo-padrao {
  background-color: var(--roxo-superficie);
  color: var(--roxo-primario);
  border: 1px solid var(--roxo-superficie);
}

.membro-detalhe {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--cinza-medio);
  min-width: 0;
}

.membro-detalhe svg {
  flex-shrink: 0;
  color: var(--cinza-medio);
}

.detalhe-texto {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* ========== ESTADOS DE CARREGAMENTO / ERRO / VAZIO ========== */
.estado-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 16px;
  text-align: center;
  gap: 12px;
}

.estado-texto {
  margin: 0;
  color: var(--cinza-medio);
  font-size: 14px;
}

.estado-vazio h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: var(--roxo-primario);
}

.vazio-icone-circulo {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: var(--roxo-superficie);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--roxo-claro);
}

.erro-icone {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--vermelho-claro);
  color: var(--vermelho-escuro);
  font-size: 20px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

.spinner {
  width: 36px;
  height: 36px;
  border: 3px solid var(--roxo-superficie);
  border-top-color: var(--roxo-medio);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.btn-tentar-novamente {
  padding: 8px 18px;
  border-radius: 8px;
  border: 1.5px solid var(--roxo-primario);
  background: var(--branco);
  color: var(--roxo-primario);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  font-family: var(--font-base);
}

.btn-tentar-novamente:hover {
  background: var(--roxo-superficie);
}


/* ========== TRANSIÇÃO SUAVE ========== */
.modal-fade-enter-active {
  transition:
    opacity 0.32s cubic-bezier(0.16, 1, 0.3, 1),
    backdrop-filter 0.32s cubic-bezier(0.16, 1, 0.3, 1);
}

.modal-fade-leave-active {
  transition:
    opacity 0.22s cubic-bezier(0.4, 0, 1, 1),
    backdrop-filter 0.22s cubic-bezier(0.4, 0, 1, 1);
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
  backdrop-filter: blur(0px);
}

.modal-fade-enter-active .modal-content {
  transition:
    transform 0.35s cubic-bezier(0.16, 1, 0.3, 1),
    opacity 0.32s cubic-bezier(0.16, 1, 0.3, 1);
  will-change: transform, opacity;
}

.modal-fade-leave-active .modal-content {
  transition:
    transform 0.22s cubic-bezier(0.4, 0, 1, 1),
    opacity 0.22s cubic-bezier(0.4, 0, 1, 1);
  will-change: transform, opacity;
}

.modal-fade-enter-from .modal-content {
  opacity: 0;
  transform: scale(0.95) translateY(16px);
}

.modal-fade-leave-to .modal-content {
  opacity: 0;
  transform: scale(0.97) translateY(8px);
}

@media (max-width: 680px) {
  .cards-membros-grid {
    grid-template-columns: 1fr;
  }

  .acao-hero-banner {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
